export default "__VITE_ASSET__NbWsACPq__"